import * as React from "react";

function GiftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m256 85.46 24.1-41.01C296.3 16.91 325.9 0 357.8 0h2.2c48.6 0 88 39.4 88 88 0 14.4-3.5 27.1-9.6 40H464c26.5 0 48 21.5 48 48v64c0 20.9-13.4 38.7-32 45.3V448c0 35.3-28.7 64-64 64H96c-35.35 0-64-28.7-64-64V285.3C13.36 278.7 0 260.9 0 240v-64c0-26.5 21.49-48 48-48h25.6c-6.14-12.9-9.6-25.6-9.6-40 0-48.6 39.4-88 88-88h2.2c31.9 0 61.5 16.91 77.7 44.45L256 85.46zM288 176v64h176v-64H288zm-64 0H48v64h176v-64zm0 112H80v160c0 8.8 7.16 16 16 16h128V288zm64 176h128c8.8 0 16-7.2 16-16V288H288v176zm72-336c22.1 0 40-17.9 40-40 0-22.09-17.9-40-40-40h-2.2c-14.9 0-28.7 7.91-36.3 20.78L286.7 128H360zm-134.7 0-34.8-59.22C182.9 55.91 169.1 48 154.2 48H152c-22.1 0-40 17.91-40 40 0 22.1 17.9 40 40 40h73.3z"
  }));
}

const ForwardRef = React.forwardRef(GiftIcon);
export default ForwardRef;